import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Col, Row, Form, Button, Input } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import "./ContactUsPage.css";
import logoLight from "../../../assets/images/logo-light.png";
import { sendContactUsMessage } from "../../../store/policies/actions";

const ContactUsPage = () => {
  let { lang } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [contact] = useState([]);

  document.title = `${t("Common.Contact Us")} | ${t(
    process.env.REACT_APP_HEADING
  )}`;

  /**
   * Formik handling
   */
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: contact.password || "",
      email: contact.name || "",
      subject: contact.Subject || "",
      message: contact.message || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(),
      email: Yup.string().required(),
      subject: Yup.string().required(),
      message: Yup.string().required().min(50),
    }),

    onSubmit: (values) => {
      dispatch(sendContactUsMessage(values));
      setTimeout(() => {
        alert(t("Common.Message sent successfully"));
      }, 1000);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
  });

  return (
    <React.Fragment>
      <div className="container-fluid mt-3" dir={lang === "ar" ? "rtl" : "ltr"}>
        <Row>
          <Col lg={12}>
            <div className="text-center mt-sm-5 text-white-50">
              <div>
                <Link to="/" className="d-inline-block auth-logo">
                  <img src={logoLight} alt="" height="125" />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <section className="ftco-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="wrapper">
                  <div className="row no-gutters">
                    <div className="col-lg-8 col-md-7 order-md-last d-flex align-items-stretch">
                      <div className="contact-wrap w-100 p-md-5 p-4">
                        <h3 className="mb-4">{t("Common.Get in touch")}</h3>
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                          className="contactForm"
                        >
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <div className="form-group">
                                <label className="label" htmlFor="name">
                                  {t("Fields.Full Name")}
                                </label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  placeholder={t("Fields.Name")}
                                  required
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.name || ""}
                                  invalid={
                                    validation.touched.name &&
                                    validation.errors.name
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="label" htmlFor="email">
                                  {t("Fields.Email Address")}
                                </label>
                                <Input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  placeholder={t("Fields.Email")}
                                  required
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.email || ""}
                                  invalid={
                                    validation.touched.email &&
                                    validation.errors.email
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <label className="label" htmlFor="subject">
                                  {t("Fields.Subject")}
                                </label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="subject"
                                  placeholder={t("Fields.Subject")}
                                  required
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.subject || ""}
                                  invalid={
                                    validation.touched.subject &&
                                    validation.errors.subject
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <label className="label" htmlFor="message">
                                  {t("Fields.Message")}
                                </label>
                                <textarea
                                  name="message"
                                  className="form-control"
                                  cols="30"
                                  rows="4"
                                  placeholder={t("Fields.Message")}
                                  required
                                  minLength={50}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.message || ""}
                                  invalid={
                                    validation.touched.message &&
                                    validation.errors.message
                                      ? true
                                      : false
                                  }
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <Button type="submit" className="btn btn-success">
                                {t("Common.Send Message")}
                              </Button>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-5 d-flex align-items-stretch">
                      <div className="info-wrap bg-primary w-100 p-md-5 p-4">
                        <h3>{t(`Common.Let's get in touch`)}</h3>
                        <p className="mb-4">
                          {t(
                            "Messages.Information.We are open for any suggestion or just to have a chat"
                          )}
                        </p>
                        <div className="dbox w-100 d-flex align-items-center">
                          <div className="icon d-flex align-items-center justify-content-center">
                            <span className="ri-phone-line"></span>
                          </div>
                          <div className="text" style={{ paddingLeft: "10px" }}>
                            <p>
                              <span>{t("Fields.Phone")}:</span>
                              <a href="tel://+966539691676">+966 53 969 1676</a>
                            </p>
                          </div>
                        </div>
                        <div className="dbox w-100 d-flex align-items-center">
                          <div className="icon d-flex align-items-center justify-content-center">
                            <span className="ri-mail-line"></span>
                          </div>
                          <div className="text" style={{ paddingLeft: "10px" }}>
                            <p>
                              <span>{t("Fields.Email")}:</span>{" "}
                              <a href="support@mrtah.com">support@mrtah.com</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactUsPage);
